import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon, LoadingIcon, Pagination } from '@/components';
import { ThemeType, useTheme } from '@/contexts';
import { useMaskBoxesLazyQuery, useStatisticQuery } from '@/graphql-hooks';
import { useIgnoreBoxes } from '@/hooks';
import { ZERO_ADDRESS } from '@/lib';
import { WrapMaskbox } from '@/page-components';
import { EMPTY_LIST } from '@/utils';
import { useCallback, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './index.module.less';
import { useLocales } from './useLocales';
const PAGE_SIZE = 5;
export const BoxList = () => {
    const t = useLocales();
    const [fetchBoxes, { data: boxesData, loading }] = useMaskBoxesLazyQuery({});
    const { data: statsData } = useStatisticQuery({
        variables: {
            id: ZERO_ADDRESS,
        },
    });
    const { skips, ignoreIds, total: totalIgnored } = useIgnoreBoxes();
    const total = Math.max((statsData?.maskboxStatistic?.total || 0) - totalIgnored, 0);
    const history = useHistory();
    const location = useLocation();
    const { theme } = useTheme();
    const page = useMemo(() => {
        const p = new URLSearchParams(location.search).get('page');
        return p ? parseInt(p, 10) : 1;
    }, [location.search]);
    const navToPage = useCallback((page) => {
        history.push(`/list?page=${page}`);
    }, []);
    useEffect(() => {
        if (!page)
            return;
        fetchBoxes({
            variables: {
                skip: (page - 1) * PAGE_SIZE,
                first: PAGE_SIZE,
                from: skips,
                ignores: ignoreIds?.length === 0 ? [' '] : ignoreIds,
            },
        });
    }, [fetchBoxes, page, skips, ignoreIds]);
    if (loading) {
        return (_jsx("div", { className: styles.loadingBox, children: _jsx(LoadingIcon, { size: 50 }) }));
    }
    const maskboxes = boxesData?.maskboxes ?? EMPTY_LIST;
    return (_jsxs(_Fragment, { children: [maskboxes.length === 0 ? (_jsxs("div", { className: styles.status, children: [_jsx("p", { className: styles.text, children: t('No items to display.') }), _jsx(Icon, { type: theme === ThemeType.Light ? 'empty' : 'emptyDark', size: 96 })] })) : (_jsx("ul", { className: styles.list, children: maskboxes.map((maskbox) => (_jsx("li", { className: styles.item, children: _jsx(WrapMaskbox, { boxOnSubgraph: maskbox, inList: true }) }, maskbox.box_id))) })), _jsx(Pagination, { className: styles.paginaton, page: page, total: total, size: PAGE_SIZE, onChange: navToPage })] }));
};
